
import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgke312aRequest, Sgke312aResponseSearchresultHyojiInfo, Sgke312aResponseSearchresultList, Sgke313aRequest, Sgke313aRequestUpdateCndtList, Sgke903aRequest, Sgke903aResponseCompanyAreaInfo, Sgke903aResponseInitialhyojiInfo, Sgkz011aRequest, Szza012aRequest } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';

import { TimeApiService, UsedSgkz011aService } from 'cbc-shared-lib';
import { UsedSgke903aService } from '../../../../../sg-ke-shared/services/used-sgke903a.service';
import { UsedSgke312aService } from '../../services/used-sgke312a.service';
import { UsedSgke313aService } from '../../services/used-sgke313a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { UsedSzza012aService } from '../../../../../sg-ke-shared/services/used-szza012a.service';


@Component({
  selector: 'app-sgke310d',
  templateUrl: './sgke310d.component.html',
  styleUrl: './sgke310d.component.scss'
})
export class Sgke310dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 検索結果リスト */
  searchresultList: Array<Sgke312aResponseSearchresultList> = new Array<Sgke312aResponseSearchresultList>();
  /** 検索結果表示情報 */
  searchresultHyojiInfo: Sgke312aResponseSearchresultHyojiInfo;
  /** 会社地区情報 */
  cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo> = new Array<Sgke903aResponseCompanyAreaInfo>();
  /** 会社地区初期表示情報 */
  cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;
  /** コード変換マスタマップ */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
  /** 業務日付 */
  businessDate: Date;
  /** 業務日付取得APIリクエスト */
  requestSzza012a: Szza012aRequest;

  /** ユーザ情報取得APIリクエスト */
  requestSgkz011a: Sgkz011aRequest;
  /** 未精算関連承認検索APIリクエスト */
  requestSgke312a: Sgke312aRequest;
  /** 未精算関連承認APIリクエスト */
  requestSgke313a: Sgke313aRequest;
  /** SGKE312Aリクエストデータフォーム */
  sgke312arequestForm: UntypedFormGroup = this.fb.group({});

  /** 画面ID */
  private static GAMEN_ID = 'SGKE310D';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {UsedSgkz011aService} initService
   * @param {UsedSgke903aService} companyAreaInfoService
   * @param {UsedSgke312aService} searchService
   * @param {UsedSgke313aService} registService
   * @param {CodeConversionMstService} codeConversionMstService
   * @param {ChangeDetectorRef} cd
   * @param {UntypedFormBuilder} fb
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke310dComponent
   */
  constructor(
    public initService: UsedSgkz011aService,
    public getDateService: UsedSzza012aService,
    private timeApiService: TimeApiService,
    private companyAreaInfoService: UsedSgke903aService,
    public searchService: UsedSgke312aService,
    public registService: UsedSgke313aService,
    private codeConversionMstService: CodeConversionMstService,
    private cd: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    public responseMsgUtils: ResponseMsgUtils,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke310dComponent
   */
  ngOnInit(): void {
    // コード変換マスタ取得
    this.codeConversionMstService.getCodeConversionMst(['S300090'])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        // ローカルに保存
        this.codeConversionMstMap = data;
      });

          // リクエスト情報をもつオブジェクトを定義
    this.requestSzza012a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      businessDayKbn: null
    };

    // SZZA012A呼び出し
    this.getDateService.doSzza012a(this.requestSzza012a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.todayDay) {
          this.businessDate = this.timeApiService.convertStringToDate(response.todayDay);
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      }
    );

    this.companyAreaInfo();
  }

  /**
   * 購読解除
   * @memberof Sgke310dComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * SGKE903A_会社地区情報取得API呼出し
   * @memberof Sgke310dComponent
   */
  companyAreaInfo() {
    let requestInfo: Sgke903aRequest = {
      requestCommon: undefined,
      reqBusinessArea: {
        gamenId: Sgke310dComponent.GAMEN_ID
      }
    };

    this.companyAreaInfoService.doSgke903a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.responseBusinessArea) {
          this.cmpnyAreaList = response?.responseBusinessArea.companyAreaInformationlist;
          this.cmpnyAreaInit = response?.responseBusinessArea.initialhyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });

  }

  /**
   * 検索ボタン押下時処理
   * @param {boolean} [reSearch=false]
   * @memberof Sgke310dComponent
   */
  onClickSearch(reSearch: boolean = false): void {

    // searchResult初期化
    this.searchresultList.length = 0;
    this.cd.detectChanges();

    // 再検索時はメッセージエリアをクリアしない・リクエストを作らない（初回検索時のリクエストを再利用する）/
    if (!reSearch) {
      this.clearErrorMsg();
      // リクエスト情報をもつオブジェクトを定義
      this.requestSgke312a = this.sgke312arequestForm.getRawValue() as Sgke312aRequest;
    }

    // SGKE312A呼び出し
    this.searchService.doSgke312a(this.requestSgke312a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.searchresultList) {
          this.searchresultList = response.searchresultList;
          this.searchresultHyojiInfo = response.searchresultHyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

      },
      error => {
      }
    );
  }

  /**
   * クリアボタン押下時処理
   * @memberof Sgke310dComponent
   */
  onClickClear(): void {
    // エラーメッセージクリア
    this.clearErrorMsg();
    this.searchresultList.length = 0;
    this.searchresultHyojiInfo = null;
  }

  /**
   * 登録ボタン押下時処理
   * @param {Sgke312aResponseSearchresultList[]} selected
   * @memberof Sgke310dComponent
   */
  onClickRegist(selected: Sgke312aResponseSearchresultList[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // オブジェクト生成関数
    let updateCndtListFunc = function (row: Sgke312aResponseSearchresultList): Sgke313aRequestUpdateCndtList {
      return {
        suppntSpno: row.suppntSpno,
        supplystopresumptionRrkno: row.supplystopresumptionRrkno,
        payCtrNo: row.payCtrNo,
        pressChargenumber: row.pressChargenumber,
        supplystopForceEonflg: row.supplystopForceEonflg,
        supplystopBreakPlndate: row.supplystopBreakPlndate,
        supplystopWorkPlndate: row.supplystopWorkPlndate,
        srvCtrNo: row.srvCtrNo,
        firstSrvctrNo: row.firstSrvctrNo,
        logicDeviceNo: row.logicDeviceNo,
        sumaddMatomecode: row.claimMatomeDivcd,
        suppntCompanygroupcode: row.companygroupcode,
        companycode: row.companycode.codeValue,
        areacode: row.areaSuppnt.codeValue,
        baseCode: row.base.codeValue,
        supplystopResumeSts: row.supplystopResumeSts.codeValue,
        sougouDivcd: row.gasEquipmentinformation.sougouDivcd,
        sougouSupplydestinationNo: row.gasEquipmentinformation.sougouSupplydestinationNo,
        energyClscode: row.gastype.codeValue,
        meterClsfy: row.gasEquipmentinformation.meterClsfy,
        meterDiscrm: row.gasEquipmentinformation.meterDiscrm,
        meterNo: row.gasEquipmentinformation.meterNo,
        meterAbility: row.gasEquipmentinformation.meterAbility,
        meterBunruiCode: row.gasEquipmentinformation.meterBunruiCode,
        metermodel: row.gasEquipmentinformation.metermodel,
        metershishinSigdigs: row.gasEquipmentinformation.metershishinSigdigs,
        supplydestinationAddrCode: row.gasEquipmentinformation.supplydestinationAddrCode,
        supplydestinationAddr: row.gasEquipmentinformation.supplydestinationAddr,
        supplydestinationBantiGou: row.gasEquipmentinformation.supplydestinationBantiGou,
        supplydestinationTatemononame: row.gasEquipmentinformation.supplydestinationTatemononame,
        supplydestinationAim: row.gasEquipmentinformation.supplydestinationAim,
        gasOpenclosevalveState: row.gasEquipmentinformation.gasOpenclosevalveState,
        attendanceKahi: row.gasEquipmentinformation.attendanceKahi,
        autolockUmuFlg: row.gasEquipmentinformation.autolockUmuFlg,
        autolockPin: row.gasEquipmentinformation.autolockPin,
        autolockKeyStoragelocation: row.gasEquipmentinformation.autolockKeyStoragelocation,
        etcKeyInfo: row.gasEquipmentinformation.etcKeyInfo,
        supplydestinationNaviInfo: row.gasEquipmentinformation.supplydestinationNaviInfo,
        jikaiKenshinPlndate: row.gasEquipmentinformation.jikaiKenshinPlndate,
        jijikaiKenshinPlndate: row.gasEquipmentinformation.jijikaiKenshinPlndate,
        jijijikaiKenshinPlndate: row.gasEquipmentinformation.jijijikaiKenshinPlndate,
        pressmoneyUpdatesequencenumber: row.pressmoneyUpdatesequencenumber,
        pressmoneyExUpdatesequencenumber: row.pressmoneyExUpdatesequencenumber,
        forcestpbreakScdUpdatesequencenumber: row.forcestpbreakScdUpdatesequencenumber,
        supplystopresumptionPointinfomngUpdatesequencenumber: row.supplystopresumptionPointinfomngUpdatesequencenumber,
      };
    }

    // 承認リクエスト情報をもつオブジェクトを定義
    this.requestSgke313a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      updateCndtList: selected.map(updateCndtListFunc)
    };

    // SGKE313A呼び出し
    this.registService.doSgke313a(this.requestSgke313a).pipe(takeUntil(this.onDestroy$)).subscribe(

      response => {
        if (response) {
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

          // 再検索
          this.onClickSearch(true);
        }
      },
      error => {
      }
    );
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke310dComponent
   */
  public clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }
  /**
   * 請求ポータルを新規タブで表示
   * @param row 
   */
  navigateBillPortal(row:Sgke312aResponseSearchresultList): void{
    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;
    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;
    // 起動元画面
    let launchSourceScreen: string = row.launchSourceScreen;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = launchSourceScreen;

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く
    window.open(`${url}${params}`, '_blank');
  }
}
